import { Fetch } from '../helpers/fetchWrapper';

const AICampaignService = {
    _url: `${process.env.REACT_APP_AI_CAMPAIGN_API_URL}`,

    async autoFillFields(payload) {
        let res = await Fetch.post(`${this._url}/auto-fill-fields`, payload);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const { message } = await res.json();
        throw new Error(message ?? 'Something Went Wrong');
    },
    async regenerateMessage(payload) {
        let res = await Fetch.post(`${this._url}/regenerate-message`, payload);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const { message } = await res.json();
        throw new Error(message ?? 'Something Went Wrong');
    },
};

export default AICampaignService;
